import { render, staticRenderFns } from "./oth-form.html?vue&type=template&id=0ffbb6ac&scoped=true&external"
import script from "./oth-form.js?vue&type=script&lang=js&external"
export * from "./oth-form.js?vue&type=script&lang=js&external"
import style0 from "./oth-form.scss?vue&type=style&index=0&id=0ffbb6ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbb6ac",
  null
  
)

export default component.exports